export const ESettingsWorkspaceTab = {
  CREDITS_TOP_UP: 'credits_top_up',
  CREDITS_TRANSACTIONS: 'credits_transactions',
  CREDITS_STATISTICS: 'credits_statistics',
  CREDITS_LIMITS: 'credits_limits',
  FEATURES_ACCESS: 'features_access',
  GENERAL: 'general',
  INVOICES: 'invoices',
  SHARED_ENTITIES: 'shared_entities',
  SUBSCRIPTION: 'subscription',
  USERS: 'users',
};
